class HeaderController {
  auth: any;
  public viewName: string;
  public expandSidebar : boolean = true;
  public sidebarHidden: boolean = true;

  get userName(): string {
    return this.authService.getUserName();
  }

  /** @ngInject */
  constructor($state: any, $scope: angular.IScope, $transitions: any,
  $cookies:angular.cookies.ICookiesService,private authService : any ) {
    var _this = this;
    _this.auth = authService;
  }

  logout(event){
    this.auth.logout(event); 
  }
  
  toggleSidebarExpansion(){
    this.expandSidebar = !this.expandSidebar;
    if(this.expandSidebar){
      $('body').removeClass('sidebar-mini')
    }else{
      $('body').addClass('sidebar-mini')
    }
  }


  collapseSidebar_smallScreen(){
    if(this.sidebarHidden){
      document.getElementById("mySidebar").style.display = "block";
    }else{
      document.getElementById("mySidebar").style.display = "none";
    }
    this.sidebarHidden = !this.sidebarHidden;
  }

}
export const header: angular.IComponentOptions = {
  template: require('./header.html'),
  controller: HeaderController
};



// WEBPACK FOOTER //
// ./src/app/layout/header.ts